import { useAuthStore } from '../stores/authStore';

export function Header() {
  const { user, clearAuth } = useAuthStore();

  const handleLogout = () => {
    clearAuth();
  };

  return (
    <div className="bg-white shadow">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            {/* Page title will be added dynamically */}
            <div className="flex-shrink-0 flex items-center">
              <h1 className="text-2xl font-semibold text-gray-900">
                Welcome back, {user?.firstName || 'User'}
              </h1>
            </div>
          </div>
          
          <div className="ml-4 flex items-center md:ml-6">
            {/* User menu */}
            <div className="ml-3 relative">
              <div className="flex items-center space-x-4">
                <span className="text-sm text-gray-700">
                  {user?.email}
                </span>
                <button
                  onClick={handleLogout}
                  className="btn btn-outline text-sm"
                >
                  Sign out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
